export const admin = '/admin';
export const foreman = '/foreman';
export const pm = '/pm';



// WEBPACK FOOTER //
// ./src/components/Routes/RoutePaths.jsx